import React, { useEffect } from 'react'
import { Box } from '@material-ui/core'
import { useHistory, useParams } from 'react-router'
import { WORKSPACE_URL_PATTERN, WORKSPACE_ID_PARAM } from 'src/constants/urlConstants'

interface AdNetworkTabLayoutProps {
  children: React.ReactNode
}

export const AdNetworkTabLayout: React.FC<AdNetworkTabLayoutProps> = ({ children }) => {
  const history = useHistory()
  const { workspaceId } = useParams<{ workspaceId: string }>()

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (!event.data || event.data.eventName !== 'adNetworkNavigate') return

      const path = event.data.data?.path
      if (!path) return

      const cmsPath = `${WORKSPACE_URL_PATTERN.replace(WORKSPACE_ID_PARAM, encodeURIComponent(workspaceId))}${path}`
      history.push(cmsPath)
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [history, workspaceId])

  return (
    <Box style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 64px)' }}>
      <Box style={{ flex: 1, minHeight: 0 }}>
        {children}
      </Box>
    </Box>
  )
}
